<div style="height: 100%;">
  <jqxGrid #gridDirecciones [theme]="environment.tema" [width]="'99%'" [height]="'100%'" [source]="adapterDirecciones" [autoshowloadelement]='false'
    [columnsresize]="true" [localization]="langGrid" [filterable]="true" [showfilterrow]="false" [columngroups]="columnsGroupDirecciones"
    [columns]="columnsDirecciones" [showrowlines]="false" [showcolumnlines]="true" [pageable]="false" [sortable]="true"
    [altrows]="true" [showstatusbar]="true" [statusbarheight]="0" [showaggregates]="false" [rowsheight]="25"
    [columnsheight]="30" [enabletooltips]="false" [editable]="false" [groupable]="true" [ready]="setRowDetails()">
  </jqxGrid>
</div>

<div #formDireccion></div>
